<ion-row>
  <ion-col size="12" size-lg="6" class="ion-padding real-life-description">
    <ul class="dark">
      <li>On weekdays, complete 8-14 hours of online course content. This is self-paced, so you decide how and when to work this into your schedule.</li>
      <li>Collaborate daily with your 14 classmates and your expert instructor.</li>
      <li>On weekends, attend 4-hour live workshops led by your instructor, so you can get the hands-on help you need.</li>
      <li>Stay engaged with your classmates during the week on a dedicated community channel and collaborate on your portfolio project.</li>
      <li>Receive instructor guidance and support throughout the week in a private chat.</li>
    </ul>
  </ion-col>
  <ion-col size="12" size-lg="6" class="ion-padding ion-text-center" *ngIf="windowRef.isBrowserRendering()">
    <youtube
      [video]="{id: 'HMVNq00CaJs', height: 280, width: 480, alt: 'Nucamp Coding Bootcamp: Most Affordable and Voted Best Bootcamp by Graduates', thumbnail: 'https://storage.googleapis.com/nucamp-production.appspot.com/Videos/Nucamp%20Brand%20Video%20720p.webp'}">
    </youtube>
  </ion-col>
</ion-row>
